import { render, staticRenderFns } from "./VListProductItems.vue?vue&type=template&id=cb200058&scoped=true&"
import script from "./VListProductItems.vue?vue&type=script&lang=js&"
export * from "./VListProductItems.vue?vue&type=script&lang=js&"
import style0 from "./VListProductItems.vue?vue&type=style&index=0&id=cb200058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb200058",
  null
  
)

export default component.exports